<template>
  <div class="container mt-100">
    <div class="row">
      <div class="col-12">
        <h3 align="center">Estamos en mantenimiento volveremos a la brevedad posible</h3>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "Maintenance"
}
</script>

<style>
  .mt-100 { margin-top: 100px; }
</style>
